<template>
  <div class="">
    <van-nav-bar
      title="捡漏专区"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
   <van-swipe :autoplay="2000">
        <van-swipe-item
          v-for="(image, index) in [1,2,3]"
          :key="index"
          @click="goswipe(image.adv_url)"
        >
          <img
            class="imgss"
            src="../../assets/jl.jpg"
          />
          <!-- <img v-lazy="image.adv_img" /> -->
        </van-swipe-item>
        <!-- <van-swipe-item>
          <img src="../../assets/swipe.png" />
          <img v-lazy="image" />
        </van-swipe-item> -->
      </van-swipe>
      <!-- <div class="time" v-show="!tfg">
<van-count-down  millisecond :time="time " @finish="finish()" >
              <template #default="timeData">
                   <span class="block">此活动还剩</span>
                   <span class="block c1">{{ timeData.days }}</span>
                   <span class="block"> 天 &nbsp;&nbsp; </span>

                   <span class="block c1">{{ timeData.hours }}</span>
                   <span class="block"> : </span>

                   <span class="block c1">{{ timeData.minutes }}</span>
                   <span class="block"> : </span>

                   <span class="block c1">{{ timeData.seconds }}</span>
                   <span class="block">:</span> 
                   <span class="block">{{ timeData.milliseconds }}</span> 
                   <span  class="block">开始</span>
                   </template>
            </van-count-down>
      </div> -->
       
       <div class="goods">
           <!-- <div class="activity">
        <div
          class="tu"
          @click="go"
        >
          <img
            src="../../assets/a1.jpg"
            alt=""
          />
        </div>
        <div class="wen">
          <div class="left">
            <p>各大活动，敬请期待</p>
            <p></p>
          </div>
          <div class="right">
            <van-count-down :time="time">
              <template v-slot="timeData">
                还剩
                <span class="item">{{ timeData.hours }}</span>: <span class="item">{{ timeData.minutes }}</span>:
                <span class="item">{{ timeData.seconds }}</span>
              </template>
            </van-count-down>
          </div>
        </div>
      </div> -->
      <div class="content">
        <ul>
          <li
            class="clearfix"
            v-for="v in list "
            :key="v.id"
            @click="go(v.id,v.tis,v.jianlouendtime)"
          >
          <div class="time"> 
            <van-count-down  millisecond :time="v.time " @finish="finish()" >
              <template #default="timeData">
                   <span class="block">此活动还剩</span>
                   <span class="block c1">{{ timeData.days }}</span>
                   <span class="block"> 天 &nbsp;&nbsp; </span>

                   <span class="block c1">{{ timeData.hours }}</span>
                   <span class="block"> : </span>

                   <span class="block c1">{{ timeData.minutes }}</span>
                   <span class="block"> : </span>

                   <span class="block c1">{{ timeData.seconds }}</span>
                   
                   <span  class="block">{{v.tis}}</span>
                   </template>
            </van-count-down>
            <!-- <div  class="xs" v-show="v.starttime">限时购！此商品只限当天 <span>{{new Date(parseInt(v.starttime) * 1000).getHours()+':00~'+new Date(parseInt(v.endtime) * 1000).getHours()+":00"}}</span> 时购买</div> -->
            </div>
          <div class="con">
            <img
              :src="v.thumb"
              alt=""
            >
            <p class="name">{{v.name}}</p>
            <p class="price">￥{{v.min_price}}</p>
            <!-- <p class="num">共{{v.stock+v.unit}}</p>
            <div class="progress">
                <van-progress style="" color="#ee0a24" track-color="#fff" :percentage="((v.stock-v.shengyunum)/v.stock*100).toFixed(1)" stroke-width="8"/>
            </div>
            <p class="name2">还剩{{v.shengyunum+v.unit}}购完</p> -->
            <p class="name3">你刚好要，我刚好有，一切都是刚刚好</p>
          </div>
           
          </li>
         
        </ul>
      </div>
       </div>
 <specs
      @specs="S_show"
        ref="child"
      v-show="specs_show"
    ></specs>
  </div>
</template>
<script>
import Vue from 'vue'
import Specs from './specs1.vue'
import { NavBar, AddressList, Toast,Swipe, SwipeItem, Lazyload,CountDown,Progress } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Swipe)
  .use(SwipeItem)
  .use(Lazyload, { lazyComponent: true }).use(CountDown).use(Progress);
export default {
  created () {
       if (JSON.parse(localStorage.getItem('user')).id != 0) {
      this.login = 1
    } else {
    }
    if ([16, 17, 23].indexOf(this.$store.state.shopid) == -1) {
      this.jf = true
    } else {
      this.jf = false
    }
    this.axios
        .get('getjianlougoods', {
          params: {
            store_id: this.$store.state.shopid,
          },
        }).then(res=>{
          // console.log(res)
          // console.log(Date.parse(new Date()))
          res.data.data.forEach(v => {
            if(v.jianloustarttime*1000-(Date.parse(new Date()))>0){
              v.time=v.jianloustarttime*1000-(Date.parse(new Date()))
              v.tis='开始'
            }else{
            v.time=v.jianlouendtime*1000-(Date.parse(new Date()))
v.tis="结束"
            }
            // v.time=v.jianlouendtime*1000-(Date.parse(new Date()))

          });
          this.list=res.data.data
        }).catch(ref=>{})
  },
  data () {
    return {
      chosenAddressId: '1',
       time: 3000,
     list:[],
     specs_show:false,
    sid:'',
    pname:'',
    oid:[],
    tfg:false,
    };
  },
  methods: {
   
   
    onClickLeft () {
      this.$router.go(-1)
    },
    goswipe(v){

    },
    S_show (v) {
      this.specs_show = v
    },
   go(id,st,ed){
    if(st=='开始'){
      Toast('还未到购买时间！')
return
    }

//     if(JSON.parse(localStorage.getItem('vip')).id==0){
//   Toast('此商品只能超级会员购买')
// return
// }
 if(ed*1000-(Date.parse(new Date()))<=0){
            Toast('此活动已结束~')
            return
            }

    this.$router.push({ name: 'product', query: { id,jian:1 } })
    return false
     if(this.login!=1){
      Toast('请先登录')
      return
     }
     if(sy<=0){
      Toast('已购完')
      return

     }
    //  console.log(st)
    //  console.log(Date.parse(new Date()))
     if(Date.parse(new Date())<st*1000 ){
      Toast('此商品于'+ new Date(parseInt(st) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ') +"开启购买")
      return
     }
    // console.log(st)
    if(st){
       if(new Date(parseInt(st) * 1000).getHours()<=new Date().getHours() && new Date(parseInt(et) * 1000).getHours()>new Date().getHours()){
      // console.log(1)
     }else{
      // console.log(2)
      return
     }
    }else{
      // console.log(1)
    }
     
     if(vip==1){

     }
    //  if(this.oid.indexOf(v)!=-1){
    //    Toast('此活动以结束！')
    //    return false
    //  }else{
 
    //  }
     this.$refs.child.parentMsg(v,i,s,zs,yh,dif,di);
       this.specs_show=true
     
   },
   finish(){
    //  console.log(v)
     this.list.forEach(v => {
            if(v.jianloustarttime*1000-(Date.parse(new Date()))>0){
              v.time=v.jianloustarttime*1000-(Date.parse(new Date()))
              v.tis='开始'
            }else{
            v.time=v.jianlouendtime*1000-(Date.parse(new Date()))
            v.tis='结束'
            }
            })
   }
    
    
  },
  components: {
    Specs,
    // One
  },
}
</script>
<style lang="less" scoped>
//  .time{
//           text-align: center;
//           color: rgb(243, 95, 95);
//           background-color: rgb(242, 225, 225);
//           font-size: 0.5rem;
//           line-height: 1.5rem;
//           .block{
//             font-size: 0.45rem;
//              display: inline-block;
//              padding-left: 0.1rem;
//           }
//           .c1{
//             color: rgb(247, 17, 17);
//             font-size: 0.45rem;
//           }
//           .xs{
//             color: rgb(14, 14, 14);
//             font-size: 0.48rem;
//             span{
//             color: rgb(247, 17, 17);
//               font-size: 0.4rem;
//             }
//           }
//         }
.activity {
    height: 6.266667rem;
    overflow: hidden;
    border-radius: 0.4rem;
    .tu {
      width: 100%;
      height: 4.293333rem;
    }
    .wen {
      background-color: #fff;
      height: 2rem;
      display: flex;
      .left {
        padding-top: 0.5rem;
        padding-left: 0.2rem;
        flex: 0.6;
        p:nth-child(1) {
          font-weight: 700;
          height: 0.64rem;
        }
        p:nth-child(2) {
          color: #f00;
        }
      }
      .right {
        color: #575c66;
        padding-top: 0.6rem;
        flex: 0.4;
      }
    }
  }
  .content {
    flex: 1;
    .title {
      text-align: center;
      font-size: 0.4rem;
      height: 1rem;
    }
    ul {
      li {
        // float: left;
        // width: 45%;
        // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
        // padding-left: 0.1rem;
        // padding-right: 0.1rem;
        // margin-left: 0.1rem;
        margin: 0.2rem 0 0.2rem 0.2rem;
       
.time{
          text-align: center;
          color: rgb(243, 95, 95);
          background-color: rgb(242, 225, 225);
          font-size: 0.4rem;
          .block{
            font-size: 0.35rem;
             display: inline-block;
             padding-left: 0.1rem;
          }
          .c1{
            color: rgb(247, 17, 17);
            font-size: 0.35rem;
          }
          .xs{
            color: rgb(14, 14, 14);
            font-size: 0.38rem;
            span{
            color: rgb(247, 17, 17);
              font-size: 0.4rem;
            }
          }
        }
        .con{
            height: 2.7rem;
        background-color: rgb(238, 236, 236);

        }
        img {
          width: 2.666667rem;
          float: left;
          margin-right: 0.2rem;
        }
        .price {
          height: 0.9rem;
          line-height: 0.9rem;
          font-size: 0.4rem;
          color: #a22d2b;
        }
        .name {
          font-size: 0.373333rem;
            padding-top: 0.2rem;

          color: #333;


        }
        .progress{
            // overflow: hidden;
            padding-top: 0.2rem;
           margin-left: 3rem;
            width: 65%;
        }
        .num{
            // float: right;
            // height: 2rem;
            text-align: right;
            padding-right: 0.2rem;
            // line-height: -2rem;
        }
        .name2 {
          font-size: 0.373333rem;
          color: #333;
         padding: 0.1rem;
         padding-top: 0.2rem;
        }
         .name3 {
          font-size: 0.373333rem;
          color: rgb(241, 49, 49);
         padding: 0.1rem;
         padding-top: 0.5rem;
        }
      }
    }
  }
</style>